import './app/kernel';
import * as formspree from "./module/formspree";

document.addEventListener('DOMContentLoaded', () => {
    const locale = document.getElementById('html')
        .getAttribute('lang')
        .replace('-', '_')
    ;

    formspree.render('#pre-catalog', locale);
});
